module.exports = __webpack_public_path__ + "img/temp-blog-02.ba58f102.jpg";